import { motion } from "framer-motion";
import { Context, PropsWithChildren, ReactNode, useContext } from "react";
import SVG from "react-inlinesvg";

import UserSVG from "@krea/customer-features/images/svg/arrow-down-colorless.svg";
import Container from "@krea/customer-features/shared-components/container";
import { twMerge } from "@krea/shared/design-system/tailwind-utils";

import { IProgressBarContext } from "./context";

const motionSteps = {
  hidden: {
    opacity: 0,
    height: 0,
    borderTop: "0px solid rgba(255, 255, 255, 0)",
  },
  visible: {
    opacity: 1,
    height: "auto",
    borderTop: "1px solid #ebe8ef",
  },
};

const motionArrow = {
  hidden: {
    transform: "rotateZ(0deg)",
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
  visible: {
    transform: "rotateZ(180deg)",
    transition: {
      duration: 0.6,
      ease: "easeOut",
    },
  },
};

interface IProgressBarMobileProps {
  title: ReactNode;
  isOpen: boolean;
  context: Context<IProgressBarContext>;
}

const ProgressBarMobile = ({
  title,
  children,
  isOpen,
  context,
}: PropsWithChildren<IProgressBarMobileProps>) => {
  const thisContext = useContext(context);

  return (
    <>
      <div
        aria-hidden
        className={"tw-h-[56px] tw-w-full tw-shrink-0 tw-grow-0"}
        onClick={thisContext.showSteps}
      >
        <Container className="tw-h-full">
          <div className="tw-flex tw-h-full tw-items-center tw-justify-between">
            {title}

            <motion.div
              variants={motionArrow}
              initial="hidden"
              animate={isOpen ? "visible" : "hidden"}
              className={twMerge(
                "tw-shrink-0 tw-text-black tw-ml-2 tw-p-3 -tw-mr-2 tw-w-10 tw-h-10",
              )}
            >
              <div className="tw-relative">
                <SVG
                  className="tw-absolute tw-left-0 tw-top-0 tw-h-auto tw-w-full tw-fill-current tw-text-current"
                  src={UserSVG}
                />
              </div>
            </motion.div>
          </div>
        </Container>
      </div>

      <motion.div
        variants={motionSteps}
        initial="hidden"
        animate={isOpen ? "visible" : "hidden"}
        transition={{
          default: { duration: 0.4, ease: "easeOut" },
        }}
        className="tw-shrink tw-grow tw-overflow-hidden"
      >
        <Container>
          <div className="tw-flex tw-justify-center tw-py-4">{children}</div>
        </Container>
      </motion.div>
    </>
  );
};

export default ProgressBarMobile;
